module.exports = __webpack_public_path__ + "img/icon-my-questions.9210ed0b.png";